export default function initAccordion() {
  const openedClass = 'opened';

  document.querySelectorAll('.accordion').forEach(holder => {
    let prevItem = 0;
    const accordionItems = holder.querySelectorAll('li');
    
    accordionItems.forEach((item, i) => {
      if (item.classList.contains(openedClass)) prevItem = i;

      const opener = item.querySelector('.opener');

      opener?.addEventListener('click', (e)=>{
        e.preventDefault();
        
        item.classList.toggle(openedClass);
        opener.setAttribute('aria-expanded', item.classList.contains(openedClass));

        if (prevItem != i) {
          accordionItems[prevItem].classList.remove(openedClass);
          accordionItems[prevItem].querySelector('.opener').setAttribute('aria-expanded', false);
          prevItem = i;
        }
      });
    });
  });
}
